import fp from "lodash/fp";
import { isAsyncValidating, isDirty } from "redux-form";

import { APP_EDIT_FORM_NAME_FEES } from "globalConstants";
import { withResetState } from "store/hocs";

import { applicationEditConstants } from "./applicationEdit.constants";

const initialState = {
	application: {},
	error: "",
	loading: true,
	attachmentsProcessing: false,
	submitting: false,
	isDataSaved: false,
};

export const getEditAppState = state => state.applicationEdit;

// prettier-ignore
const selector = property =>
	fp.flow(getEditAppState, fp.get(property));

export const getIsDataSaved = selector("isDataSaved");

const EDIT_APP_FORMS = [
	"processorEditForm",
	"businessEditForm",
	"principalEditForm",
	APP_EDIT_FORM_NAME_FEES,
	"additionalServicesEditForm",
	"softwareOptionsEditForm",
	"signApplicationEditForm",
];

export const getCanSaveApplication = state => {
	const canSaveForm = formName =>
		!isAsyncValidating(formName)(state) && isDirty(formName)(state);

	// Equivalent to
	// return (
	//   canSaveForm(form1) ||
	//   canSaveForm(form2) ||
	//   canSaveForm(form3) ||
	//   ...
	// );
	return EDIT_APP_FORMS.reduce((acc, cur) => acc || canSaveForm(cur), false);
};

export const getEditAppIsDirty = state => {
	return EDIT_APP_FORMS.reduce(
		(acc, cur) => acc || isDirty(cur)(state),
		false,
	);
};

function applicationEdit(state = initialState, action) {
	switch (action.type) {
		case applicationEditConstants.EDIT_APPLICATION_SUBMIT_REQUEST:
			return {
				...state,
				submitting: true,
			};
		case applicationEditConstants.EDIT_APPLICATION_SUBMIT_SUCCESS:
			return {
				...state,
				submitting: false,
				isDataSaved: true,
			};
		case applicationEditConstants.EDIT_APPLICATION_SUBMIT_FAILURE:
			return {
				...state,
				submitting: false,
			};
		case applicationEditConstants.GET_APPLICATION_REQUEST: {
			return {
				...state,
				loading: true,
			};
		}
		case applicationEditConstants.GET_APPLICATION_SUCCESS: {
			return {
				...state,
				application: action.application,
				loading: false,
			};
		}
		case applicationEditConstants.GET_APPLICATION_ERROR: {
			return {
				...state,
				error: action.error,
				loading: false,
			};
		}
		case applicationEditConstants.RESET_APPLICATION_EDIT_STATE: {
			return { ...initialState };
		}

		default:
			return state;
	}
}

export default withResetState({ initialState })(applicationEdit);
